import React, {useState, useEffect} from "react";
import {connect} from 'react-redux';
//import ProgressBar from 'react-bootstrap/ProgressBar'
//import Table from 'react-bootstrap/Table'
import moment from 'moment';
//import Pagination from 'react-js-pagination';
//import Pagination from 'react-bootstrap/Pagination';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Container from '@material-ui/core/Container';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@material-ui/core/CardContent';
//import Divider from '@material-ui/core/Divider';
import { Divider, makeStyles, useMediaQuery, useTheme} from '@material-ui/core';
import {styled} from '@mui/material/styles';
import MaterialTable from "@material-table/core";
import { ExportCsv, ExportPdf } from '@material-table/exporters';
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
//import Spinner from 'react-bootstrap/Spinner';
//import Button from 'react-bootstrap/Button';
//import Modal from 'react-bootstrap/Modal';
//import PageItem from 'react-bootstrap/PageItem'
//import { Redirect } from 'react-router-dom';
//import { NavLink, Link } from 'react-router-dom';
//import {LinkContainer} from 'react-router-bootstrap';
//import { Nav, NavItem} from "react-bootstrap";
//import DeleteModal from './DeleteModal';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import DataTable from 'react-data-table-component';
import TextField from '@material-ui/core/TextField';
import * as actions from '../store/actions/index';
//import {makeStyles} from "@material-ui/core/styles/index";
//
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
//

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    header: {
        textAlign: 'left',
        spacing: 10,
    }
}));

const StyledChip = styled(Chip)(({theme}) => ({
    fontSize: 12,
    "& .MuiChip-label":{
      padding: '2px 5px 1px'
    },
    margin: '0px',
    borderRadius: '1px',
    color: '#fff'
}));

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

function SuperResellers(props) {

    const classes = useStyles();
    const [dataRows, setDataRows] = useState();
    const [filterText, setFilterText] = useState('');
    const [filterData, setFilterData] = useState([]);
    const theme = useTheme();
    const isSmallOrLess =
        useMediaQuery(theme.breakpoints.down('sm'));
        
    useEffect(() => {
        console.log('logging dashboard super reseller list');
        props.onInitializeGetSuperReseller();
        props.onInitializeAddSuperReseller();
        props.onInitializeSaveSuperReseller();
        props.onGetSuperResellerList(props.token);

    }, []);

    const setCurrentSuperReseller = (sreseller) => {
        console.log('RESELLERS:: reseller name: ', sreseller);
        props.onSetSuperReseller(sreseller);
        props.history.push('/updatesuperreseller');
        //setClient(client);
    };

    // let loading = (
    //     <Container>
    //         <Row>
    //             <Col></Col>
    //             <Col>
    //                 <Spinner animation="border" role="status">
    //                     <span className="sr-only">Loading...</span>
    //                 </Spinner>
    //             </Col>
    //             <Col></Col>
    //         </Row>
    //     </Container>
    // );

    let superResellersData = [];

    useEffect(() => {
        if (props.superResellers && props.superResellers.length){
            superResellersData = props.superResellers.map((sreseller) => {
                //console.log('inside client map', client);
                return {
                    //login: <a href="#" onClick={() => setCurrentSuperReseller(sreseller.name)}>{sreseller.name}</a>,
                    login: sreseller.name,
                    name: sreseller.name,
                    description: sreseller.description,
                    //mac: client.mac,
                    created: moment(sreseller.created).format('YYYY-MM-DD'),
                    credits: sreseller.credits,
                    resellers: sreseller.resellerCount,
                    dealers: sreseller.dealersCount,
                    clients: sreseller.clientsCount

                };
            });
            setDataRows(superResellersData);
            setFilterData(superResellersData);
        }
    },[props.superResellers]);

    useEffect(() => {
        //console.log('insided useEffect', filterText);
        if (dataRows && dataRows.length){
            //console.log('filter data', clientsData);
            let data = dataRows.filter(item => {
                if(item.name && item.name.toLowerCase().includes(filterText.toLowerCase())){
                    return true;
                } else if (item.description && item.description.toLowerCase().includes(filterText.toLowerCase())) {
                    return true;
                } else {
                    return false;
                }
            });
            setFilterData(data);
        }

    }, [filterText]);

    const sortIcon = <ArrowDownward />;

    const dataColumnsMaterial = [

        {
            title: 'Login',
            field: 'login',
            render: (rowData) => <a href="#" onClick={() => setCurrentSuperReseller(rowData.login)}>{rowData.login}</a>,
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            }

        },
        {
            title: 'Created',
            field: 'created',
            cellStyle: {
                fontSize: 13,
                padding: '6px'
            },
            hidden: isSmallOrLess,
            //width: '6%'
        },
        {
            title: 'Credits',
            field: 'credits',
            cellStyle: {
                fontSize: 12,
                padding: '0px'
            },
            //width: '3%'
        },
        {
            title: 'Resellers',
            field: 'resellers',
            hidden: isSmallOrLess,
            cellStyle: {
                fontSize: 12,
                padding: '0px',
                //overflow: 'hidden',
                //width: 10,
                //textOverflow: 'ellipsis'

            }
        },
        {
            title: 'Dealers',
            field: 'dealers',
            hidden: isSmallOrLess,
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            }
        },
        {
            title: 'Clients',
            field: 'clients',
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            }
        },
        {
            title: 'Description',
            field: 'description',
            hidden: isSmallOrLess,
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            }
        }
    ];


    const dataColumns = [
        {
            name: 'Login',
            selector: 'login',
            sortable: false,
            width: 150
        },
        {
            name: 'Created',
            selector: 'created',
            sortable: true,
            width: 200
        },
        {
            name: 'Credits',
            selector: 'credits',
            sortable: true,
            width: 200
        },
        {
            name: 'Resellers',
            selector: 'resellers',
            sortable: true,
            width: 200
        },
        {
            name: 'Dealers',
            selector: 'dealers',
            sortable: true,
            width: 200
        },
        {
            name: 'Clients',
            selector: 'clients',
            sortable: true,
            width: 200
        }
    ];

    const detailsPanel = [
        props => {
            if (!isSmallOrLess){
                return {
                    icon: () => null,
                    render: () => null
                }
            }
            
            return {
                disabled: !isSmallOrLess,
                render: (rowData) => {
                    return (
                        <Box sx={{ flexGrow: 1, padding: "5px" }}>
                        <Grid container spacing={3}>
                            <Grid item zeroMinWidth >
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <Typography sx={{fontSize: 13, fontWeight: 'bold'}} variant="h6" component="div">
                                        Created
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {rowData.rowData.created} 
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item zeroMinWidth >
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <Typography sx={{fontSize: 13, fontWeight: 'bold'}} variant="h6" component="div">
                                        Resellers
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {rowData.rowData.resellers} 
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item zeroMinWidth >
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <Typography sx={{fontSize: 13, fontWeight: 'bold'}} variant="h6" component="div">
                                        Dealers
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {rowData.rowData.dealers} 
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item zeroMinWidth >
                                <Grid container spacing={1}>
                                    <Grid item>
                                    <Typography sx={{fontSize: 13, fontWeight: 'bold'}} variant="h6" component="div">
                                        Description
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {rowData.rowData.description}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        </Box>
                    )
                }
            }
        }
        
    ];



    return (
        <Container maxWidth="xl" disableGutters={isSmallOrLess}>
            <Grid container spacing={2}>
                <Grid item md={12}></Grid>
                <Grid item md={12} sm={12} xs={12}>
                    <Paper elevation={5}>
                        <Card>
                            <CardHeader
                                title="Super Resellers"
                                titleTypographyProps={{
                                    fontSize: 17,
                                    fontWeight: 'bold'
                                }}
                            />
                            <Divider variant="middle" />
                            <CardContent>
                            <MaterialTable
                                    icons={tableIcons}
                                    columns={dataColumnsMaterial}
                                    data={filterData}
                                    detailPanel={detailsPanel}
                                    title=""
                                    options={{
                                        pageSize: 10,
                                        emptyRowsWhenPaging: false,
                                        pageSizeOptions: [10, 20, 30, 40, 50, 100],
                                        padding: "dense",
                                        headerStyle: {padding: '0px', fontWeight: 'bold', fontSize: 13},
                                        tableLayout: "auto",
                                        actionsColumnIndex: -1,
                                        exportMenu: [{
                                            label: 'Export PDF',
                                            exportFunc: (dataColumnsMaterial, filterData) => ExportPdf(dataColumnsMaterial, filterData, 'myClients')
                                        }, {
                                            label: 'Export CSV',
                                            exportFunc: (dataColumnsMaterial, filterData) => ExportCsv(dataColumnsMaterial, filterData, 'myClients')
                                        }]
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onGetSuperResellerList: (token) => dispatch(actions.superResellerList(token)),
        onInitializeGetSuperReseller: () => dispatch(actions.initializeGetSuperReseller()),
        onInitializeAddSuperReseller: () => dispatch(actions.initializeAddSuperReseller()),
        onInitializeSaveSuperReseller: () => dispatch(actions.initializeSaveSuperReseller()),
        onSetSuperReseller: (name) => dispatch(actions.setSuperReseller(name))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        total: state.superResellers.total,
        isLoading: state.superResellers.loading,
        superResellers: state.superResellers.super_reseller_list

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SuperResellers);